'use strict';
var linchpin = require('./recipe'),
	_ = require('lodash');

var product = {
	initProductViewGalleryTracker: function () {
		$('.product-thumbnails').on('click', '.thumb:not(.selected)', function (e) {
			var obj = {
				'event': 'productViewGallery',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
			};
			$.extend(obj, getProductData());
			$.extend(obj, getMiscData());
			$.extend(obj, getImageClicked($(this).find('img')));
			dataLayer.push(obj);
		});
	},
	initProductDetailsTracker: function () {
		$('.product-tabs li a').on('click', function (e) {
			var obj = {
				'event': 'productDetails',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name,
				'product_details_viewed': $(this).text()
			};
			$.extend(obj, getProductData());
			$.extend(obj, getMiscData());
			dataLayer.push(obj);
		});
	},
	initProductIngredientsTracker: function () {
		$('.product-tabs li a[href="#tabIngredients"]').on('click', function (e) {
			var obj = {
				'event': 'productIngredients',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
			};
			$.extend(obj, getProductTabData());
			dataLayer.push(obj);
		});
	},
	initProductReviewsTracker: function () {
		$('.product-tabs li a[href="#tabReviews"]').on('click', function (e) {
			var obj = {
				'event': 'productReviews',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
			};
			$.extend(obj, getProductTabData());
			dataLayer.push(obj);
		});
	},
	initTastingExAddToBagTracker: function () {
		$('#add-to-cart').on('click', function (e) {
			var obj = {
				'event': 'tastingExAddToBag',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
			};
			var productData = getProductData();
			// Check if a customer add a tasting experience to the bag
			/*jshint camelcase:false */
			if (productData.tasting_location !== undefined && productData.tasting_location !== '') {
				$.extend(obj, productData);
				$.extend(obj, getMiscData());
				dataLayer.push(obj);
			}
		});
	},
	initRecipeBagTracker: function () {
		$('.recipe-wrapper .add-to-cart').on('click', function (e) {
			var obj = {
				'event': 'recipeAddToBag',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
			};
			var productData = getProductData();
			$.extend(obj, productData);
			$.extend(obj, getMiscData());
			dataLayer.push(obj);
		});
	},
	initGiftcardAddToBagTracker: function () {
		$('.pdp-main').on('click', '#add-to-cart', function (e) {
			var productData = getProductData();
			// Check if a customer add a gift card to the bag
			/*jshint camelcase:false */
			if (productData.giftcard_type !== undefined && productData.giftcard_type !== '') {
				var obj = {
					'event': 'giftcardAddToBag',
					'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
				};
				$.extend(obj, productData);
				$.extend(obj, getMiscData());
				dataLayer.push(obj);
			}
		});
	},
	initClickAndCollectTracker: function () {
		$('body').on('click', '#order-via-click-and-collect', function (e) {
			var obj = {
				'event': 'clickAndCollect',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name
			};
			$.extend(obj, getProductData());
			$.extend(obj, getMiscData());
			$.extend(obj, getStoreData($(this)));
			dataLayer.push(obj);
		});
	},
	initDropAHintTracker: function () {
		$('body').on('click', 'button[name$=_dropahint_send]', function (e) {
			var obj = {
				'event': 'dropAHint',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name,
				're_email_address': $('input[name$=_dropahint_theiremail]').val(),
				're_email_permit': $('input[name$=_dropahint_receivenews]').prop('checked') === true ? 'yes' : 'no',
				're_first_name': $('input[name$=_dropahint_theirname]').val(),
				're_message': $('textarea[name$=_dropahint_note]').val(),
				're_sale_image': $('.primary-image') ? $('.primary-image').prop('src') : '',
				're_sale_link': window.location.href
			};
			$.extend(obj, getProductData());
			$.extend(obj, getMiscData());
			dataLayer.push(obj);
		});
	},
	triggerCheckStoreStockEvent: function () {
		var clickCollectButton = $('#order-via-click-and-collect');
		if (clickCollectButton.attr('data-gtmstore') !== null) {
			var obj = {
				'event': 'checkStoreStock',
				'button_ID': 'storesList'
			};
			$.extend(obj, getProductData());
			$.extend(obj, getMiscData());
			$.extend(obj, getStoreData(clickCollectButton));
			dataLayer.push(obj);
		}
	},
	initAddToWishlistTracker: function () {
		$('.wishlist-wrapper').on('click', 'a', function () {
			if (($(this).attr('data-content') === 'wishlist')) {
				var obj = {
					'event': 'addToWishlist',
					'button_ID': $(this).title,
					'wishlist_add': 'wishlist item added',
					'wishlist_product_ID': $('.product-number span').text()
				};
				$.extend(obj, getProductData());
				dataLayer.push(obj);
			}
			if (($(this).attr('data-content') === 'recipe')) {
				// GTM Linchpin analytics
				if (SitePreferences.GTM_ENABLED) {
					linchpin.addRecipeEvent(this);
				}
			} else if ($(this).attr('data-recipe')) {
				// GTM Linchpin analytics
				if (SitePreferences.GTM_ENABLED) {
					linchpin.printRecipeEvent(this);
				}
			}
		});
	},
	triggerNotifyWhenInStockEvent: function () {
		var obj = {
			'event': 'notifyWhenInStock',
			'button_ID': ''
		};
		$.extend(obj, getProductData());
		$.extend(obj, getMiscData());
		dataLayer.push(obj);
	},
	initQuickViewTabEvents: function () {
		$('.product-tabs li a').on('click', function (e) {
			var obj = {'button_ID': e.currentTarget.id};
			if ($(this).attr('href') === '#tab1') {
				var description = {'event': 'quickViewDescription'};
				$.extend(obj, description);
			}
			if ($(this).attr('href') === '#tab2') {
				var ingredients = {'event': 'quickViewIngredients'};
				$.extend(obj, ingredients);
			}
			$.extend(obj, getProductData());
			dataLayer.push(obj);
		});
	},
	triggerQuickViewEvent: function () {
		var obj = {
			'event': 'quickView',
			'button_ID': ''
		};
		$.extend(obj, getProductData());
		$.extend(obj, getMiscData());
		dataLayer.push(obj);

		// init tab events on quickview
		this.initQuickViewTabEvents();
	},
	triggerAddVoucherEvent: function () {
		if ($('input[name=AppliedVoucher]').length > 0) {
			var obj = {
				'event': 'productAddVoucher',
				'button_ID': 'dwfrm_reservespecial_applyVoucher',
				'voucher_ID': $('input[name=AppliedVoucher]').val(),
				'voucher_total': $('input[name=AppliedVoucherValue]').val(),
				'customer_contact_settings': ''
			};
			if ($('input[name=pageLoadData]').length > 0) {
				var pageLoad = JSON.parse($('input[name=pageLoadData]').val());
				if (pageLoad.contact_pref) {
					obj.customer_contact_settings = pageLoad.contact_pref;
				}
			}
			$.extend(obj, getProductData());
			$.extend(obj, getMiscData());
			dataLayer.push(obj);
		}
	},
	triggerReserveNowEvent: function () {
		var obj = {
			'event': 'reserveNow',
			'button_ID': 'dwfrm_reservespecial_reserveNow'
		};

		$.extend(obj, getReservedProductData());
		dataLayer.push(obj);
	},
	triggerQuickViewReserveEvent: function () {
		var obj = {
			'event': 'quickViewReserve',
			'button_ID': 'dwfrm_reservespecial_reserveNow'
		};

		$.extend(obj, getReservedProductData());
		dataLayer.push(obj);
	},
	socialButtonsEvent: function (e) {
		var linkSite = '';
		if (e.currentTarget.className.indexOf('facebook') > -1) {
			linkSite = '[https://www.facebook.com/HotelChocolat]';
		} else if (e.currentTarget.className.indexOf('twitter') > -1) {
			linkSite = '[https://twitter.com/HotelChocolat]';
		} else if (e.currentTarget.className.indexOf('pinterest') > -1) {
			linkSite = '[https://pinterest.com/hotelchocolat]';
		} else {
			linkSite = '[https://plus.google.com/u/0/+hotelchocolat/about]';
		}
		var obj = {
			'event': 'socialButtons',
			'button_ID': e.currentTarget.className ? e.currentTarget.className : '',
			'outbound_link_name': $(e.currentTarget).first().find('span.at4-visually-hidden').text(),
			'outbound_link_site': linkSite
		};
		dataLayer.push(obj);
	},
	trackPageView: function () {
		var obj = {
			'event': 'quickViewClose'
		};
		dataLayer.push(obj);
	},
	productImpressionAndClickTrackingEvents: function () {
		$('input[name=productImpression]').each(function (index) {
			var $this = $(this);
			var product = JSON.parse($this.val());
			if (!$('div[data-itemid=' + product.impression_position + ']').hasClass('already-seen')) {
				var obj = {
					'event': 'productImpressionTracking',
					'button_ID': '',
					'impression_product_brand': product.impression_product_brand,
					'impression_position':index + 1,
					'impression_price': product.impression_price,
					'impression_product_category': product.impression_product_category,
					'impression_product_name': product.impression_product_name,
					'impression_product_SKU':product.impression_product_SKU,
					'impression_product_variant': product.impression_product_variant
				};
				dataLayer.push(obj);
				$('div[data-itemid=' + product.impression_position + ']').on('click', function () {
					var _obj = {
						'event': 'productClickTracking',
						'button_ID': '',
						'impression_product_brand': product.impression_product_brand,
						'impression_position':index + 1,
						'impression_price': product.impression_price,
						'impression_product_category': product.impression_product_category,
						'impression_product_name': product.impression_product_name,
						'impression_product_SKU':product.impression_product_SKU,
						'impression_product_variant': product.impression_product_variant
					};
					dataLayer.push(_obj);
				});
				$('div[data-itemid=' + product.impression_position + ']').addClass('already-seen');
			}
		});
	}
};

/**
 * Returns an object which contains reserved product data
 * Reserved product data is taken either from the html or from hidden input field on PDP
 *
 * @returns Object
 */
function getReservedProductData() {
	var productDataInput = $('input[name=productData]'),
		obj = {},
		productObj = {};

	if (productDataInput.length > 0) {
		productObj = JSON.parse(productDataInput.val());
		obj['product_brand'] = productObj.productBrand;
		obj['product_category'] = productObj.productCategory;
		obj['product_discount'] = productObj.productDiscount;
		obj['product_hierarchy'] = productObj.productHierarchy;
		obj['product_ID'] = productObj.productID;
		obj['product_name'] = productObj.productName;
		obj['product_price'] = productObj.price;
		obj['product_SKU'] = productObj.productSKU;
		obj['product_vat'] = productObj.tax;
	}
	obj['product_price_old'] = getOldPrice();
	obj['product_quantity'] = $('input[name=Quantity]').val();
	obj['product_stock_status'] = getAvailabilityMsg();
	obj['product_variant'] = getProductVariant();
	obj['product_voucher'] = $('input[name=AppliedVoucher]').val() || '';

	return obj;
}

/**
 * Returns an object which contains data required for product tab events
 * Product data is taken either from the html or from hidden input field on PDP
 *
 * @returns Object
 */
function getProductTabData() {
	var obj = {},
		productObj = getProductData(),
		keysToCopy = [
			'product_brand',
			'product_category',
			'product_hierarchy',
			'product_image',
			'product_quantity',
			'product_SKU'
		];
	_.forEach(keysToCopy, function (key) {
		obj[key] = productObj[key];
	});

	return obj;
}

/**
 * Returns an object which contains product data
 * that is mainly identical for all GTM events that are triggered on PDP.
 * Product data is taken either from the html or from hidden input field on PDP
 *
 * @returns Object
 */
function getProductData() {
	if ($('input[name=productData]').length > 0) {
		var productObj = JSON.parse($('input[name=productData]').val());
		// object to be pushed
		var obj = {
			'product_brand': productObj.productBrand,
			'product_category': productObj.productCategory,
			'product_gifting_occasion': '',
			'product_gifting_selection': '',
			'product_hierarchy': productObj.productHierarchy,
			'product_ID': productObj.productID,
			'product_image': $('.primary-image') ? $('.primary-image').prop('src') : '',
			'product_name': productObj.productName,
			'product_price': productObj.price,
			'product_price_old': getOldPrice(),
			'product_quantity': $('input[name=Quantity]').val(),
			'product_SKU': productObj.productSKU,
			'product_stock_status': getAvailabilityMsg(),
			'product_variant': getProductVariant(),
			'review_total_rating': $('.bv-rating-ratio-number span.bv-rating').text(),
			're_recipe_image': $('.primary-image') ? $('.primary-image').prop('src') : '',
			're_sms_optout': ''
		};
		// Add Tasting Adventure specific values
		if (productObj.taLocation !== null && productObj.taDateTime !== null) {
			var taObj = {
				'tasting_location': productObj.taLocation,
				'tasting_date': productObj.taDateTime,
				'tasting_type': ''
			};
			$.extend(obj, taObj);
		}
		// Add Gift Card specific values
		if (productObj.giftCardType !== null) {
			var giftObj = {
				'giftcard_type': productObj.giftCardType,
				'giftcard_amount': $('input[name$=_purchase_amount]').val(),
				'giftcard_send_date': $('input[name$=_purchase_sendDate]').length > 0 ? $('input[name$=_purchase_sendDate]').val() : ''
			};
			$.extend(obj, giftObj);
		}
		return obj;
	}
}

function getMiscData() {
	if ($('input[name=pageLoadData]').length > 0) {
		var data = JSON.parse($('input[name=customerPageLoadData]').val());
		// object to be pushed
		var obj = {
				're_sms_optout': data.re_sms_optout
		};
		return obj;
	}
}
/**
 * Return an object which contains store data
 * Input parameter Check Store Stock button element
 * which has additional attribute (data-gtmstore) with store data.
 *
 * @param button
 * @returns Object
 */
function getStoreData(button) {
	var storeData = JSON.parse(button.attr('data-gtmstore'));
	var obj = {
		'store_ID': storeData.ID,
		'store_name': storeData.name,
		'store_postcode': storeData.postalCode,
		'store_stock_status': $('#check-store-stock-result .stock-msg').text()
	};
	return obj;
}

/**
 * Utility function to get availability message from PDP page
 *
 * @returns {String}
 */
function getAvailabilityMsg() {
	var availabilityMsg = '';
	if ($('.availability-msg').children(0).length > 1) {
		if ($('.slick-active').length > 0) {
			var messageDiv = $('.slick-active').find('.availability-msg');
			if (messageDiv.length > 0) {
				availabilityMsg = messageDiv.find('.availability-msg').text().trim();
			}
		}
	} else {
		availabilityMsg = $('.availability-msg').children(0).text();
	}
	return availabilityMsg;
}

/**
 * Utility function to get old price from PDP page
 *
 * @returns {String}
 */
function getOldPrice() {
	var oldPrice = '';
	if ($('.product-price .price-standard').length > 0) {
		oldPrice = $('.product-price .price-standard').text().substring(1);
	}
	return oldPrice;
}

/**
 * Utility function to get product variant value
 *
 * @returns {String}
 */
function getProductVariant() {
	var variant = '';
	if ($('.variation-select').find('option:selected').length > 0) {
		variant = $('.variation-select').find('option:selected').text().trim();
	}
	return variant;
}

/**
 * Utility function to get image url that was clicked
 *
 * @param img element that was clicked
 * @returns {Object}
 */
function getImageClicked(img) {
	if (img.attr('data-lgimg').length > 0) {
		var imageObj = JSON.parse(img.attr('data-lgimg'));
		var image = {
			'product_image': imageObj.url ? imageObj.url : ''
		};
		return image;
	}
}

module.exports = product;
